class VideoEquipe extends HTMLElement {
  constructor() {
    super();
    this.videos = this.querySelectorAll('video');
    this.observeVideo();
  }

  observeVideo() {
    const options = {
      root: null,
      rootMargin: '0px',
      threshold: 0.1
    };

    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          this.videos.forEach(video => {
            video.currentTime = 0;
            video.play();
          });
        }
      });
    }, options);

    observer.observe(this);
  }
}

customElements.define('video-equipe', VideoEquipe);
